<template>
  <div class="records-container">
    <!-- 导航栏 -->
    <div class="nav-bar">
      <div class="back-btn" @click="goBack">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="nav-title" style="margin-right: 10px;">生成记录</div>
      <div class="nav-actions">
        <i class=""></i>
        <i class=""></i>
      </div>
    </div>

    <!-- 记录列表 -->
    <div class="record-list">
      <div class="record-item" v-for="record in records" :key="record.id">
        <div class="image-container">
          <!-- 根据状态显示不同内容 -->
          <template v-if="record.status == '1'">
            <div class="generating-placeholder">
              <div class="ai-logo">AI</div>
              <div class="generating-text">生成中...</div>
              <div class="generating-progress">{{ record.progress || 0 }}%</div>
            </div>
          </template>
          <template v-else>
            <div class="video-container" v-if="record.dictName=='video'">
              <video
                :src="record.fileUrl"
                class="video"
                controls
              ></video>
              <div class="video-overlay" @click="openVideoPlayer(record.fileUrl)">
                <i class="el-icon-zoom-in"></i>
              </div>
            </div>
            <div class="image-container" v-else  @click="toDetails(record)">
              <img
                src="../../assets/video/play.png"
                class="record-image"
                alt="生成音频"
                @click="playVideo"
              />
            </div>
          </template>
        </div>

        <!-- 记录信息 -->
        <div class="record-title">{{ "一键配音"}}</div>
        <div class="record-time">{{ formatTime(record.createTime) }}</div>
      </div>
    </div>

    <!-- 全屏视频播放器弹窗 -->
    <div class="video-modal" v-if="showVideoModal" @click="closeVideoPlayer">
      <div class="video-modal-content" @click.stop>
        <div class="video-modal-close" @click="closeVideoPlayer">
          <i class="el-icon-close"></i>
        </div>
        <video
          ref="fullScreenVideo"
          :src="currentVideoUrl"
          class="full-screen-video"
          controls
          autoplay
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
import { pageAnchorUserWork } from "../../api/video";

export default {
  name: "Records",
  data() {
    return {
      records: [],
      pollingTimer: null,
      workId: null,
      page: 1,
      size: 10,
      showVideoModal: false,
      currentVideoUrl: '',
    };
  },
  methods: {
    goBack() {
      this.stopPolling();
      this.$router.back();
    },
    formatTime(time) {
      if (!time) return "";
      const date = new Date(time);
      return date.toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
    playVideo() {
      if (this.records && this.records.videoUrl) {
        window.open(this.records.videoUrl, "_blank");
      }
    },
    openVideoPlayer(videoUrl) {
      this.currentVideoUrl = videoUrl;
      this.showVideoModal = true;
    },
    closeVideoPlayer() {
      const video = this.$refs.fullScreenVideo;
      if (video) {
        video.pause();
      }
      this.showVideoModal = false;
      this.currentVideoUrl = '';
    },
    toDetails(item) {
      this.$router.push({
        name: 'details',
        query: {
          extra: item.extra || '',
          name: item.name || '',
          videoUrl: item.fileUrl || '',
          id: item.id || '',
          createTime: item.createTime || '',
          userId: item.userId || '',
        }
      });
    },
    async fetchWorkStatus() {
      try {
        const userId = localStorage.getItem("userMes") ? (eval('(' + localStorage.getItem("userMes") + ')').phone) : "";
        console.log("fetchWorkStatus - userId:", userId);
        console.log("fetchWorkStatus - workId:", this.workId);

        const params = {
          userId: userId,
          workId: this.workId,
          page: this.page,
          size: this.size,
          type: this.type,
        };

        console.log("fetchWorkStatus - 请求参数:", params);

        const response = await pageAnchorUserWork(params);

        console.log("查询作品状态:", response);

        if (response && response.data && response.data.data) {
          const records = response.data.data;
          this.records = records.list;
        }
      } catch (error) {
        console.error("查询作品状态失败:", error);
      }
    },
    startPolling() {
      this.type = this.$route.query.type;
      this.fetchWorkStatus();
      // this.pollingTimer = setInterval(() => {
      // this.fetchWorkStatus();
      // }, 3000);
    },
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
  },
  mounted() {
    this.workId = this.$route.query.workId || "";
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
};
</script>

<style scoped>
.records-container {
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

/* 状态栏 */
.status-bar {
  height: 20px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  color: #000000;
}

.status-icons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.signal-icon {
  width: 18px;
  height: 12px;
  /* background: url('../../../assets/status/signal.png') no-repeat center; */
  background-size: contain;
}

.wifi-icon {
  width: 18px;
  height: 12px;
  /* background: url('../../../assets/status/wifi.png') no-repeat center; */
  background-size: contain;
}

.battery-icon {
  width: 26px;
  height: 12px;
  /* background: url('../../../assets/status/battery.png') no-repeat center; */
  background-size: contain;
}

/* 导航栏 */
.nav-bar {
  height: 44px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
}

.back-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #000000;
  font-size: 18px;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  color: #000000;
  font-size: 18px;
}
/* 记录列表 */
.record-list {
  padding: 0px 15px 15px 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.record-item {
  margin-bottom: 20px;
  width: 165.5px;
  height: 230px;
  /* background: rgba(0, 0, 0, 0.23); */
  border-radius: 14px;
  backdrop-filter: blur(14px);
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.record-item:active {
  transform: scale(0.98);
}

/* 生成中的占位图 */
.generating-placeholder {
  width: 100%;
  height: 100%;
  background-color: rgba(128, 128, 128, 0.3);
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  color: #fff;
}

.generating-placeholder::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(0, 128, 255, 0.1) 0%,
    rgba(255, 0, 128, 0.1) 100%
  );
}

.ai-logo {
  font-size: 30px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
  background: linear-gradient(45deg, #00b4ff, #ff0080);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.generating-text {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  position: relative;
  z-index: 1;
  margin-bottom: 5px;
}

.generating-progress {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  position: relative;
  z-index: 1;
  margin-bottom: 5px;
}

.generating-status {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  position: relative;
  z-index: 1;
}

.image-container {
  width: 100%;
  height: 180px;
  border-radius: 10px;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
}

.video-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.video{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 10px;
  cursor: pointer;
}

.video-container:hover .video-overlay {
  opacity: 1;
}

.video-overlay i {
  font-size: 40px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.record-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-30px, -70%);
}
.record-title {
  text-align: left;
  padding-left: 6px;
  margin-bottom: 8px;
}

/* 全屏视频播放器弹窗 */
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.video-modal-content {
  position: relative;
  width: 90%;
  max-width: 800px;
  max-height: 80vh;
}

.video-modal-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 32px;
  height: 32px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  color: #000;
  transition: all 0.3s ease;
}

.video-modal-close:hover {
  background-color: #fff;
  transform: scale(1.1);
}

.full-screen-video {
  width: 100%;
  height: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 8px;
  background-color: #000;
}
</style>
